
import { createSlice } from '@reduxjs/toolkit'

import { runsheetShiftTablesAdapter } from '../adapters/runsheetShiftTablesAdapter'

export const initialRunsheetShiftTableState = runsheetShiftTablesAdapter.getInitialState()

export const runsheetShiftTablesSlice = createSlice({
  name: 'runsheetShiftTables',
  initialState: initialRunsheetShiftTableState,
  reducers: {
    upsertMultipleRunsheetShiftTables: (state, action) => {
      runsheetShiftTablesAdapter.upsertMany(state, action.payload)
    },
    upsertOneRunsheetShiftTable: (state, action) => {
      runsheetShiftTablesAdapter.upsertOne(state, action.payload)
    },
    setRunsheetShiftTableLoading: (state, action) => {
      const { id, isLoading } = action.payload
      const existingShiftTable = state.entities[id]
      
      if (existingShiftTable) {
        existingShiftTable.isLoading = isLoading
      }
    },
  },
})

export const { upsertMultipleRunsheetShiftTables, upsertOneRunsheetShiftTable, setRunsheetShiftTableLoading } = runsheetShiftTablesSlice.actions
